import { render } from "./TravelPass.vue?vue&type=template&id=627ac35b&scoped=true&lang=pug"
import script from "./TravelPass.vue?vue&type=script&lang=ts"
export * from "./TravelPass.vue?vue&type=script&lang=ts"

import "./TravelPass.vue?vue&type=style&index=0&id=627ac35b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-627ac35b"

export default script